import { render, staticRenderFns } from "./SavedStyleSelector.vue?vue&type=template&id=1d5be825&"
import script from "./SavedStyleSelector.vue?vue&type=script&lang=js&"
export * from "./SavedStyleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports